import { STATUS_META } from "@/lib/format";

export function StatusBadge({ statusKey, size = "sm" }) {
  const meta = STATUS_META[statusKey] || { label: statusKey, color: "#64748B", bg: "#64748B15" };
  const sizeClass = size === "lg" ? "text-xs px-3 py-1" : "text-[11px] px-2 py-0.5";
  return (
    <span
      data-testid={`status-badge-${statusKey}`}
      className={`inline-flex items-center gap-1.5 font-medium rounded-full border ${sizeClass}`}
      style={{ backgroundColor: meta.bg, color: meta.color, borderColor: `${meta.color}30` }}
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: meta.color }} />
      {meta.label}
    </span>
  );
}
